import Vue from 'vue';
import Vuex from 'vuex';
import { shuffleArray } from '@/utils/array';
import projects from './projects';
import team from './team';

Vue.use(Vuex);

Object.entries(team).forEach(([nickname, member]) => {
  // eslint-disable-next-line no-param-reassign
  member.nickname = nickname;
});

Object.entries(projects).forEach(([name, project]) => {
  // eslint-disable-next-line no-param-reassign
  project.name = name;
});

const teamOrder = Object.keys(team);
shuffleArray(teamOrder);

const projectOrder = Object.keys(projects).reverse();

export default new Vuex.Store({
  state: {
    team,
    projects,
    selectedMemberId: teamOrder[0],
    selectedProjectId: projectOrder[0],
    layout: {},
    manualSelectedProject: false,
  },
  getters: {
    teamInOrder: state => teamOrder.map(nickname => state.team[nickname]),
    selectedMember: state => state.team[state.selectedMemberId],
    projectsList: state => projectOrder.map(name => state.projects[name]),
    selectedProject: state => state.projects[state.selectedProjectId],
    layout: state => state.layout,
    showProjectPage: state => state.manualSelectedProject,
  },
  mutations: {
    selectMember(state, payload) {
      state.selectedMemberId = payload;
    },
    selectProject(state, payload) {
      state.manualSelectedProject = true;
      state.selectedProjectId = payload;
    },
    deselectProject(state) {
      state.manualSelectedProject = false;
    },
    setLayout(state, payload) {
      state.layout = payload;
    },
  },
  actions: {
  },
  modules: {
  },
});
